import {
    FETCH_DYNAMIC_TABLE_FAILURE,
    FETCH_DYNAMIC_TABLE_REQUEST,
    FETCH_DYNAMIC_TABLE_SUCCESS,
    PATCH_DYNAMIC_TABLE, PATCH_DYNAMIC_TABLE_FAILURE, PATCH_DYNAMIC_TABLE_SUCCESS
} from "./actionTypes";
import {makeExperienceApiCall} from "../../utils/apiUtils";

// Action creators
export const fetchDynamicTableRequest = () => ({type: FETCH_DYNAMIC_TABLE_REQUEST});
export const fetchDynamicTableSuccess = (config) => ({type: FETCH_DYNAMIC_TABLE_SUCCESS, payload: config});
export const fetchDynamicTableFailure = (error) => ({type: FETCH_DYNAMIC_TABLE_FAILURE, payload: error});
export const patchDynamicTableRequest = () => ({type: PATCH_DYNAMIC_TABLE});
export const patchDynamicTableSuccess = (config) => ({type: PATCH_DYNAMIC_TABLE_SUCCESS, payload: config});
export const patchDynamicTableFailure = (error) => ({type: PATCH_DYNAMIC_TABLE_FAILURE, payload: error});
const endpoint = '/api/dynamicTableConfig';

let _dynamicTableFetched = false;

export const fetchDynamicTableData = (userId) => async (dispatch) => {
    // Skip if already fetched this session (config doesn't change mid-session)
    if (_dynamicTableFetched) return;
    _dynamicTableFetched = true;

     dispatch(fetchDynamicTableRequest());
    try {

        const response = await makeExperienceApiCall(
            endpoint,
            'GET',
            { user_id: userId })
        if (response?.status === 200 && response?.data)
            await dispatch(fetchDynamicTableSuccess(response.data));
        else {
            _dynamicTableFetched = false; // Allow retry on failure
            await dispatch(fetchDynamicTableFailure("Failed to fetch dynamic table config"));
        }

    } catch (error) {
        _dynamicTableFetched = false; // Allow retry on failure
        await dispatch(fetchDynamicTableFailure(error.message));
    }
}

// Reset the fetch guard (used on logout)
export const resetDynamicTableFetchGuard = () => {
    _dynamicTableFetched = false;
}


export const patchDynamicTableConfig = (userId, updatedConfig) => async (dispatch) => {
    await dispatch(patchDynamicTableRequest());
    await dispatch(patchDynamicTableSuccess(updatedConfig));
    const body = {
        user_id: userId,
        config: updatedConfig
    }
    try {
        const response = await makeExperienceApiCall(
             endpoint,
            'PATCH',
             { user_id: userId },
            JSON.stringify(body)
            )


        const validBody = response?.data?.code === 200
        const validStatus = response.status === 200
        if (validStatus && validBody) {
            await dispatch(patchDynamicTableSuccess(updatedConfig));
            return response;
        } else {
            const errorMessage = `Failed to update dynamic table config: ${response?.status || 'Unknown Error'}`;
            await dispatch(patchDynamicTableFailure(errorMessage));
            return null;
        }
    } catch (error) {
        await dispatch(patchDynamicTableFailure(error.message));
        return null;
    }
}

